export enum UserConfigurationModalTab {
  All = 'all',
  Collections = 'collections',
  Access = 'access',
}
